module.exports = __webpack_public_path__ + "img/pm10_es.ae9f3704.jpg";